module.exports = __webpack_public_path__ + "img/photo-icon.98dafa85.svg";